import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import CalendarSchedule from '../../Common/CalendarSchedule';
import './CleaningRequest.css';

const CleaningRequest = ({ userId }) => {
  const { t } = useLanguage();

  return (
    <div className="cleaning-request">
      <h2>{t('client.requestCleaningService', 'Request Cleaning Service')}</h2>
      <CalendarSchedule isAdmin={false} currentUserId={userId} />
    </div>
  );
};

export default CleaningRequest;
